import TopText from './TopText';
import FormTable from './FormTable';
import { useEffect, useState } from 'react';
import './PrintStyles.css';
// import { getInvoice } from '../helper/controller';

// import { collection, getDocs, limit, orderBy, query } from 'firebase/firestore';
// import { db } from '../firebase';

const Home = ({ user }) => {
  const [loading, setLoading] = useState(false);

  const [companyName, setCompanyName] = useState('');
  const [companyTRN, setCompanyTRN] = useState('');

  const [companyNameError, setCompanyNameError] = useState('');
  const [companyTRNError, setCompanyTRNError] = useState('');

  const [quotation,setQuotation] = useState('');
  const [quotationError,setQuotationError] = useState('');

  const [address,setAddress] = useState('');
  const [addressError,setAddressError] = useState('');

  // const [newInvoice, setNewInvoiceNo] = useState(null);
  // useEffect(() => {
  //   const q = query(
  //     collection(db, 'bills'),
  //     orderBy('timestamp', 'desc'),
  //     limit(1)
  //   );
  //   getDocs(q)
  //     .then((querySnapshot) => {
  //       querySnapshot.forEach((doc) => {
  //         // doc.data() is never undefined for query doc snapshots
  //         const docRaw = doc.data();
  //         const invoiceNo = docRaw.invoiceNo;
  //         const newInvoice = getInvoice(invoiceNo);
  //         setNewInvoiceNo(newInvoice);
  //       });
  //     })
  //     .catch((error) => {
  //       console.error('Error getting documents:', error);
  //     });
  // }, []);
  return (
    <div className="overflow-x-auto mx-1 md:mx-0 print:mx-0">
    <div className="animate__animated animate__fadeIn text-xs my-8 print:my-3  ">
      <TopText
        companyName={companyName}
        companyTRN={companyTRN}
        setCompanyName={setCompanyName}
        setCompanyTRN={setCompanyTRN}
        companyNameError={companyNameError}
        companyTRNError={companyTRNError}
        quotation={quotation}
        setQuotation={setQuotation}
        quotationError={quotationError}
        address={address}
        setAddress={setAddress}
        addressError={addressError}
        // newInvoice={newInvoice}
      />
      <FormTable
        companyName={companyName}
        companyTRN={companyTRN}
        setCompanyNameError={setCompanyNameError}
        setCompanyTRNError={setCompanyTRNError}
        loading={loading}
        setLoading={setLoading}
        user={user}
        quotation={quotation}
        setQuotationError={setQuotationError}
        address={address}
        setAddressError={setAddressError}
        // newInvoice={newInvoice}
      />{' '}
    </div>
    </div>
  );
};

export default Home;
